
import { defineComponent, onMounted } from 'vue';
import { setPageHeader } from '@/core/helpers/toolbar';
import AssignmentProductGroup from '@/modules/catalog/product-groups/components/AssignmentProductGroup.vue';
import ProductGroupDiscountModal from '@/modules/catalog/product-groups/components/ProductGroupDiscountModal.vue';

export default defineComponent({
    components: {
        AssignmentProductGroup,
        ProductGroupDiscountModal
    },
    setup() {
        onMounted(() => {
            setPageHeader({
                title: 'message.ASSIGNMENT message.PRODUCT_GROUPS',
                actionButton: null,
                breadCrumbs: [
                    { name: 'message.HOME', link: '/dashboard' },
                    { name: 'message.CATALOG', link: '#' },
                    { name: 'message.PRODUCT_GROUPS', link: '/catalog/product_groups' },
                    { name: 'message.ASSIGNMENT message.PRODUCT_GROUPS' }
                ]
            });
        });
    }
});
